import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-267">
      <div className="max-w-3xl mx-auto text-center" data-id="element-268">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-269">
          Si sos docente de Português en Argentina,
          <br data-id="element-270" />
          <span className="text-[#39FF14]" data-id="element-271">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-272">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-273">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-274">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-275">
              Domingo a la noche buscando actividades que no se adaptan al
              alumno argentino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-276">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-277">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-278">
              Llegás al lunes con material sin estructura, sin cierre y sin
              solucionario
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-279">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-280">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-281">
              Planificaciones armadas a las corridas la noche anterior
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-282">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-283">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-284">
              Evaluaciones siempre iguales, sin banco de instrumentos ni
              solucionario
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-285">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-286">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-287">
              Temas difíciles (verbos irregulares, subjuntivo, falsos amigos)
              sin saber cómo explicarlos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-288">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-289">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-290">
              Alumnos con NEE o distintos niveles y sin material adaptado
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-291">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-292">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-293">
              Cada domingo volvés a empezar el ciclo de buscar, armar e
              improvisar
            </p>
          </div>
        </div>

        <p className="text-[#39FF14] text-2xl sm:text-3xl font-black mb-8" data-id="element-294">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Green divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#39FF14] to-transparent w-full" data-id="element-295" />
      </div>
    </section>;
}